<!-- Zweck: Stellt die HTML-Struktur für app layouts loggedin component im Frontend bereit. -->
<customer-service-watcher></customer-service-watcher>
<app-navbar></app-navbar>
<app-loader [class.printhidden]="psvc.printing|async"></app-loader>
<domain-suggestions></domain-suggestions>

<div class="sectioncontent" [class.mobile]="isMobile|async">
  <ngx-simplebar style="height: 100%">
    <div class="sectioncontent-inner" [class.mobile]="isMobile|async" [class.pagecontent]="fullheight|async">
      <app-main-menu [class.hidden]="(showType|async) != 'menu'"></app-main-menu>
      <router-outlet (activate)="activate($event)" [class.hidden]="(showType|async) != 'router'"></router-outlet>
    </div>
  </ngx-simplebar>
</div>
<div class="globalhelpbutton tut_global_helpbutton" [class.hidden]="!(show_help_button|async) || ((cbsvc.visible|async) == false)" [class.mobile]="isMobile|async">
  <contact-button></contact-button>
</div>
